import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { LocalStorage } from 'ngx-webstorage';
import { MultiSelect } from 'primeng/multiselect';
import { UserService } from 'projects/core/src/lib/login/data/user.service';
import { KanbanBoardStore } from '../../../data/kanban-board.store';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { CustomerService } from 'projects/app-misc/src/app/modules/customer/data/customer.service';

@Component({
    selector: 'app-customers-filter',
    templateUrl: './customers-filter.component.html',
    styleUrls: ['./customers-filter.component.scss']
})
export class CustomersFilterComponent implements OnInit {

    @Output()
    changeDetect = new EventEmitter<any>();

    shortCustomers: ShortObject[]

    @LocalStorage()
    filteredCustomers: number[];

    selectedCustomers: User[] = [];

    customerFiltersLabel: string;

    @Output()
    filterOn = new EventEmitter<boolean>();

    @ViewChild('multiSelect', { static: true })
    multiSelect: MultiSelect

    constructor(
        protected customerSerivce: CustomerService,
        protected kanbanBoardStore: KanbanBoardStore
    ) {

    }

    ngOnInit(): void {

        this.customerSerivce.getKBCustomersForManager().subscribe(customers => {

            this.shortCustomers = [...customers]

            let selectedCustomersIds: number[]

            if (!this.filteredCustomers) {
                this.selectedCustomers = this.shortCustomers
                selectedCustomersIds = this.shortCustomers.map(customer => customer.id);
            }
            else {
                const cIds = this.shortCustomers.map(customer => customer.id)
                const fCIds = this.filteredCustomers;

                const colsMap = new Map(this.shortCustomers.map(customer => [customer.id, customer]));

                selectedCustomersIds = cIds.filter(x => !fCIds.includes(x));
                this.selectedCustomers = selectedCustomersIds.map(id => colsMap.get(id));
            }

            this.filteredCustomers = this.shortCustomers.map(cols => cols.id).filter(colId => !selectedCustomersIds.includes(colId));

            this.kanbanBoardStore.updateCustomersFilter(this.filteredCustomers.length > 0 ? selectedCustomersIds : undefined);

            this.countFilter();
        })
    }

    updateCustomers() {
        const selectedCustomersIds = this.selectedCustomers.map(col => col.id)

        this.filteredCustomers = this.shortCustomers.map(cols => cols.id).filter(colId => !selectedCustomersIds.includes(colId));

        this.kanbanBoardStore.updateCustomersFilter(this.filteredCustomers.length > 0 ? selectedCustomersIds : undefined);

        this.countFilter();
    }

    countFilter() {
        this.customerFiltersLabel = this.selectedCustomers.length + ' customers selected';

        if (this.selectedCustomers.length === this.shortCustomers.length) {
            this.customerFiltersLabel = 'Filter Customers';

            this.filterOn.emit(false)
        }
        else {
            this.filterOn.emit(true)
        }
    }

    showAll() {
        this.multiSelect.toggleAll({})
    }


}
